// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unverifiedBlocker__zKFAB {
  background: #f6f6f6;
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 1000;
}

.card___omUr {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-top: 60px;
  max-width: 440px;
}

.logo__GZ2vy svg {
  height: 60px;
  width: 240px;
}

.title__P5sJv {
  font-weight: 400;
  font-size: 23px;
  margin-top: 5px;
}

.body__NaB_c {
  margin: 0;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/UnverifiedBlocker/unverifiedBlocker.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,OAAO;EACP,eAAe;EACf,MAAM;EACN,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB","sourcesContent":[".unverifiedBlocker {\n  background: #f6f6f6;\n  height: 100vh;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  z-index: 1000;\n}\n\n.card {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin: auto;\n  margin-top: 60px;\n  max-width: 440px;\n}\n\n.logo svg {\n  height: 60px;\n  width: 240px;\n}\n\n.title {\n  font-weight: 400;\n  font-size: 23px;\n  margin-top: 5px;\n}\n\n.body {\n  margin: 0;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"unverifiedBlocker": `unverifiedBlocker__zKFAB`,
	"card": `card___omUr`,
	"logo": `logo__GZ2vy`,
	"title": `title__P5sJv`,
	"body": `body__NaB_c`
};
module.exports = ___CSS_LOADER_EXPORT___;
